// extracted by mini-css-extract-plugin
export default {"container":"search_container__cTpBd","input":"search_input__4TnhY","searchIcon":"search_searchIcon__2MYhI"};